module.exports = __webpack_public_path__ + "static/img/5.15dcd03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/包包/5.png
// module id = bCQZ
// module chunks = 0